import * as types from '../constants/ActionTypes';
import { switchInfoAccess } from 'actions/collections'
// import keyBy from 'lodash.keyby'
//
const errorsForNoPage = ['BUILDING_IN_SELECTION_NOT_FOUND', 'SELECTION_NOT_FOUND'];

const initialState = {
  selection: {
    name: null
  },
  isLoading: false,
  buildings: []
}

export default function profile(state = initialState, action) {
    switch (action.type) {
        case types.LOAD_COLLECTION_START:
          return { ...state, isLoading: true };
        case types.LOAD_COLLECTION_SUCCESS:
          return { ...state, ...action.payload.data, buildings: action.payload.data.buildings || [], isLoading: false };
        case types.LOAD_COLLECTION_ERROR:
          return {
            ...state,
            error: action.payload.error,
            isLoading: false,
            noPageExist: errorsForNoPage.includes(action.payload.error['error-code'])
          };
        case types.LOAD_COLLECTION_BUILDING_START:
          return { ...state, isLoading: true };
        case types.LOAD_COLLECTION_BUILDING_SUCCESS:
          return {
            ...state,
            user: action.payload.data.user,
            building: action.payload.data.buildings,
            selection: action.payload.data.selection || { showInfo: '1' },
            isLoading: false,
          };
        case types.LOAD_COLLECTION_BUILDING_ERROR:
          return {
            ...state,
            error: action.payload.error,
            isLoading: false,
            noPageExist: errorsForNoPage.includes(action.payload.error['error-code'])
          };
        case types.REMOVE_FROM_COLLECTION_SUCCESS:
          if (action.payload.referal === state.selection.referal) {
            return { ...state, buildings: state.buildings.filter(building => +building.id !== +action.payload.buildingId) };
          }
          return state

        case types.ADD_TO_COLLECTION_SUCCESS:
          if (action.payload.referal === state.selection.referal) {
            return { ...state, buildings: state.buildings.concat(action.meta.data) };
          }
          return state

        case types.COMMENT_COLLECTION_SUCCESS:
          return { ...state, buildings: state.buildings.map(
            building => (+building.id === +action.payload.buildingId) ? {...building, comment: action.payload.comment} : building
          ) };

        case switchInfoAccess.request.toString():
          return {
            ...state,
            selection: {
              ...state.selection,
              showInfo: action.payload.showInfo,
            },
          };

        default:
          return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/collection.js